exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-box[data-v-fee374d8]{width:360px;margin:0 auto;padding-bottom:20px}", ""]);

// exports
